module.exports = __webpack_public_path__ + "static/media/rupee-symbol.7f0af6cd.svg";